export default function routing($stateProvider) {

    $stateProvider.state('automation', {
        url: "/automation",
        abstract: true
    })
        
    .state('automation.index', {
        url: "",
        controller: 'AutomationCtrl',
        controllerAs: 'ctrl',
        template: require('../../../views/automation/index.html'),
        ncyBreadcrumb: {
            label: 'BREADCRUMBS:AUTOMATION:INDEX'
        }
    })

    .state('automation.folder', {
        url: "/folder/{folder}",
        controller: 'AutomationCtrl',
        controllerAs: 'ctrl',
        template: require('../../../views/automation/index.html'),
        ncyBreadcrumb: {
            parent: 'automation.index',
            skip: true
        }
    })

    .state('automation.emailCreate', {
        url: "/{id}/email/create",
        controller: 'AutomationEmailCtrl',
        controllerAs: 'automationCtrl',
        template: require('../../../views/automation/email.html'),
        ncyBreadcrumb: {
            label: 'BREADCRUMBS:AUTOMATION:CREATE',
            parent: 'automation.index'
        }
    })

    .state('automation.emailEdit', {
        url: "/{id}/email/{emailId}/edit",
        controller: 'AutomationEmailCtrl',
        controllerAs: 'automationCtrl',
        template: require('../../../views/automation/email.html'),
        ncyBreadcrumb: {
            label: 'BREADCRUMBS:AUTOMATION:EDIT',
            parent: 'automation.index'
        }
    })

    .state('automation.smsCreate', {
        url: "/{id}/textMessage/create",
        controller: 'AutomationSmsCtrl',
        controllerAs: 'automationCtrl',
        template: require('../../../views/automation/sms.html'),
        ncyBreadcrumb: {
            label: 'BREADCRUMBS:AUTOMATION:CREATE',
            parent: 'automation.index'
        }
    })

    .state('automation.smsEdit', {
        url: "/{id}/textMessage/{textMessageId}/edit",
        controller: 'AutomationSmsCtrl',
        controllerAs: 'automationCtrl',
        template: require('../../../views/automation/sms.html'),
        ncyBreadcrumb: {
            label: 'BREADCRUMBS:AUTOMATION:EDIT',
            parent: 'automation.index'
        }
    })

    .state('automation.statistics', {
        url: '/{messageType}/{id}/{automationId}/statistics/{folder}',
        controller: 'StatisticsCtrl',
        controllerAs: 'ctrl',
        template: require('../../../views/statistic/statistics.html'),
        ncyBreadcrumb: {
            label: 'BREADCRUMBS:CAMPAIGN:SHOW',
            parent: 'automation.index'
        }
    })
}

routing.$inject = ['$stateProvider'];
